/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserTag } from '../../models/user-tag';

export interface GetProfileAuditors$Params {
  id: number;
}

export function getProfileAuditors(http: HttpClient, rootUrl: string, params: GetProfileAuditors$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UserTag>>> {
  const rb = new RequestBuilder(rootUrl, getProfileAuditors.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<UserTag>>;
    })
  );
}

getProfileAuditors.PATH = '/rest/profile/{id}/auditors';
